import {
  FccSdsMission,
  FccSdsRideExecutionErrorType,
} from '@backoffice-frontend/graphql/subscription'
import { useTranslation } from 'react-i18next'

export const useSelfDrivingSystemTranslations = () => {
  const { t } = useTranslation()

  const sdsMissionTranslations = (key?: FccSdsMission | null): string => {
    if (!key) return t('common_notApplicable_label')

    const map: Record<FccSdsMission, string> = {
      [FccSdsMission.Invalid]: t('adFleetMap_journeyStateInitialising_caption'),
      [FccSdsMission.Idle]: t(
        'adFleetMap_journeyStateWaitingForMission_caption',
      ),
      [FccSdsMission.SafetyCheck]: t(
        'adFleetMap_journeyStateWaitingForClearance_caption',
      ),
      [FccSdsMission.OnDuty]: t(
        'adFleetMap_journeyStateDrivingToWaypoint_caption',
      ),
      [FccSdsMission.AtStop]: t('adFleetMap_journeyStateAtWaypoint_caption'),
      [FccSdsMission.EmergencyInProgress]: t(
        'adFleetMap_journeyStateEmergencyDetected_caption',
      ),
      [FccSdsMission.EmergencyParked]: t(
        'adFleetMap_journeyStateStoppedForEmergency_caption',
      ),
      [FccSdsMission.AssessDrivingNeed]: t(
        'adFleetMap_journeyStateWaitingForNextActions_caption',
      ),
      [FccSdsMission.RequestToDrive]: t(
        'adFleetMap_journeyStateRequestToDrive_caption',
      ),
    }
    return map[key]
  }

  const sdsMissionTooltipTranslations = (
    key?: FccSdsMission | null,
  ): string => {
    if (!key) return ''

    const map: Record<FccSdsMission, string> = {
      [FccSdsMission.Invalid]: t(
        'adFleetMap_tooltip_journeyStateInitialising_caption',
      ),
      [FccSdsMission.Idle]: t(
        'adFleetMap_tooltip_journeyStateWaitingForMission_caption',
      ),
      [FccSdsMission.SafetyCheck]: t(
        'adFleetMap_tooltip_journeyStateWaitingForClearance_caption',
      ),
      [FccSdsMission.OnDuty]: t(
        'adFleetMap_tooltip_journeyStateDrivingToWaypoint_caption',
      ),
      [FccSdsMission.AtStop]: t(
        'adFleetMap_tooltip_journeyStateAtWaypoint_caption',
      ),
      [FccSdsMission.EmergencyInProgress]: t(
        'adFleetMap_tooltip_journeyStateEmergencyDetected_caption',
      ),
      [FccSdsMission.EmergencyParked]: t(
        'adFleetMap_tooltip_journeyStateStoppedForEmergency_caption',
      ),
      [FccSdsMission.AssessDrivingNeed]: t(
        'adFleetMap_tooltip_journeyStateWaitingForNextActions_caption',
      ),
      [FccSdsMission.RequestToDrive]: t(
        'adFleetMap_tooltip_journeyStateRequestToDrive_caption',
      ),
    }
    return map[key]
  }

  const sdsErrorTranslations = (key?: FccSdsRideExecutionErrorType) => {
    if (!key) return t('common_notApplicable_label')

    const map: Partial<Record<FccSdsRideExecutionErrorType, string>> = {
      [FccSdsRideExecutionErrorType.RideAcceptedTimeout]: t(
        'adFleetMap_sdsErrorRideRejectedTimeout_caption',
      ),
      [FccSdsRideExecutionErrorType.DrivingTimeout]: t(
        'adFleetMap_sdsErrorDrivingTimeout_caption',
      ),
      [FccSdsRideExecutionErrorType.RideRejectedStationary]: t(
        'adFleetMap_sdsErrorRideRejectedStationary_caption',
      ),
      [FccSdsRideExecutionErrorType.RideRejectedOnDuty]: t(
        'adFleetMap_sdsErrorRideRejectedOnDuty_caption',
      ),
    }

    return map[key] ?? key
  }

  const sdsErrorTooltipTranslations = (key?: FccSdsRideExecutionErrorType) => {
    if (!key) return ''

    const map: Partial<Record<FccSdsRideExecutionErrorType, string>> = {
      [FccSdsRideExecutionErrorType.RideAcceptedTimeout]: t(
        'adFleetMap_tooltip_sdsErrorRideRejectedTimeout_caption',
      ),
      [FccSdsRideExecutionErrorType.DrivingTimeout]: t(
        'adFleetMap_tooltip_sdsErrorDrivingTimeout_caption',
      ),
      [FccSdsRideExecutionErrorType.RideRejectedStationary]: t(
        'adFleetMap_tooltip_sdsErrorRideRejectedStationary_caption',
      ),
      [FccSdsRideExecutionErrorType.RideRejectedOnDuty]: t(
        'adFleetMap_tooltip_sdsErrorRideRejectedOnDuty_caption',
      ),
    }

    return map[key] ?? key
  }

  return {
    sdsMissionTranslations,
    sdsMissionTooltipTranslations,
    sdsErrorTranslations,
    sdsErrorTooltipTranslations,
  }
}
